import { ActionReducer, ActionReducerMap, MetaReducer } from "@ngrx/store";
import { hydrationMetaReducer } from "./hydratationReducer";
import { AppState } from "src/app/models/appState";
import { UserReducers } from "./reducers";
import { MenuReducer } from "./reducers/menu/menu.reducers";
import { StarsReducer } from "./reducers/stars/stars.reducers";

export const reducers : ActionReducerMap<AppState> = {
    
  User :                                    UserReducers.UserReducer,
  Menu :                                    MenuReducer,
  Stars :                                   StarsReducer
}

export function debug(reducer: ActionReducer<string>): ActionReducer<string> {

  return function(state, action) {
 
    return reducer(state, action);
  };
}

export const metaReducers : MetaReducer[] = [hydrationMetaReducer]